import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  icon: {
    boxSizing: 'border-box',
    width: '40px',
    height: '40px',
    padding: '5px',
    border: '1px solid #2C2D3E4D',
    borderRadius: '3px',
  },
  img: { width: '100%', height: '100%' },
}));
